<template>
  <div>
    <b-card no-body>
      <div class="d-flex mt-2 ml-2">
        <div class="p-2 flex-grow-1 my-auto">
          <div class="text-center">
            <div class="custom-event-image mb-2">
              <img
                :src="fetchImage(eventItem.image_url, 400, 300)"
                onerror="this.onerror=null;this.src='/img/SLMath/SLMath_default.png';"
              >
            </div>
          </div>
        </div>
        <div class="p-2 my-auto">
          <div class="text-center">
            <div class="text-muted regular-14">
              <span>{{ moment(eventItem.from, 'YYYY-MM-DD HH:mm:ss').format('MMM') }}</span>
            </div>
            <div class="bold-32">
              <span :class="activeItemId === eventItem.id ? 'typo-color-primary' : 'typo-color-black'">
                <span>{{ moment(eventItem.from, 'YYYY-MM-DD HH:mm:ss').format('DD') }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="p-2 ml-2 w-100 my-auto">
          <div class="text-muted regular-12">
            <span>{{ moment(eventItem.from, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
            <span> - </span>
            <span>{{ moment(eventItem.to, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
          </div>
          <div class="regular-16 mt-2">
            <span :class="activeItemId === eventItem.id ? 'typo-color-primary' : 'typo-color-black'">
              <i v-if="!eventItem.visible" v-b-tooltip.hover.top="'SLMath Only'" class="fas fa-lock" />
              {{ eventItem.name }}
            </span>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'

export default {
 name: 'LeftGridEventList',
 mixins: [mixin],
 props: ['eventItem', 'activeItemId']
}
</script>
